import { render, staticRenderFns } from "./DetalleReposicion.vue?vue&type=template&id=236588bf&"
import script from "./DetalleReposicion.vue?vue&type=script&lang=js&"
export * from "./DetalleReposicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetalleReposicion.vue"
export default component.exports